import { render, staticRenderFns } from "./ngn.vue?vue&type=template&id=74cd72c9&scoped=true"
import script from "./ngn.vue?vue&type=script&lang=js"
export * from "./ngn.vue?vue&type=script&lang=js"
import style0 from "./ngn.vue?vue&type=style&index=0&id=74cd72c9&prod&lang=css"
import style1 from "./ngn.vue?vue&type=style&index=1&id=74cd72c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cd72c9",
  null
  
)

export default component.exports